import { type GetBalanceCurrencyDTO } from '@capsicum/common';

import { type FetchWalletMeBalanceType } from '../data-access/api/wallet';

export type UseWalletsBalanceProps = { isStakable?: boolean; removeExcludedCurrencies?: boolean };

export type UseWalletsBalanceType = {
	currencies: Array<GetBalanceCurrencyDTO>;
	getCurrencyBy: (predicate: (b: GetBalanceCurrencyDTO) => boolean) => GetBalanceCurrencyDTO | undefined;
	/**
	 * Function to check if the sum of the balance of BOTH wallets has enough tokens of a specific currency.
	 */
	hasEnoughBalance: (currencyId: string, amountRequired: number) => boolean;
	hasEnoughStaked: (currencyId: string, amountRequired: number) => boolean;
	isLoading: boolean;
	/**
	 * Total fan tokens balance locked & unlocked. Excludes CHZ and SSU balances.
	 */
	totalFanTokensBalance: number;
	walletsBalance: FetchWalletMeBalanceType | undefined;
};

export const excludedCurrenciesShortcodes = ['CHZ', 'SSU'];
